import React, { useState } from 'react';
import ArrowLeft from '../../../../Assets/Arrow left.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closePreview } from '../../../../Features/storefrontSlice';
import MobileBanner from './MobileComponents/MobileBanner';
import SearchField from './MobileComponents/SearchField';
import CategorySection from './MobileComponents/CategorySection';
import SingleBanner from './MobileComponents/SingleBanner';
import CategoryCollection from './MobileComponents/CategoryCollection';
import CustomCollection from './MobileComponents/CustomCollection';
import OfferDisplay from './MobileComponents/OfferDisplay';
import AboutOne from './MobileComponents/AboutOne';
import AboutTwo from './MobileComponents/AboutTwo';
import AboutThree from './MobileComponents/AboutThree';
import FeaturesOne from './MobileComponents/FeaturesOne';
import FeaturesTwo from './MobileComponents/FeaturesTwo';
import CarouselBanner from './MobileComponents/CarouselBanner/CarouselBanner';

const OPTIONS = { loop: true, duration: 60, }

function MobilePreview() {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const [pageType, setPageType] = useState('STORE');

    function changePageType(type) {
        setPageType(type);
    }

    function handleClosePreview() {
        dispatch(closePreview());
    }

    return (
        <div className='w-screen h-screen'>
            <div className="h-[50px] w-full pl-4 flex select-none">
                <div className="flex items-center gap-2">
                    <button onClick={handleClosePreview} className="size-11 flex items-center justify-center outline-none">
                        <img src={ArrowLeft} alt="" />
                    </button>

                    <p className='font-bold text-2xl text-[#121212]'>Store Preview</p>
                </div>
            </div>

            <div className="h-[calc(100%-50px)] w-full flex items-center justify-center">
                <div className="w-[375px] h-[90%] bg-[#121212] flex flex-col gap-4 overflow-y-scroll no-scrollbar pb-4">
                    <MobileBanner />

                    <div className="w-full pb-[34px]"></div>

                    <div className="px-4 flex w-full font-medium text-[#FFFFFF] select-none text-[16px] leading-7">
                        <button onClick={() => changePageType('STORE')} className={`w-1/2 text-center py-1 outline-none border-b-2 ${pageType === 'STORE' ? 'border-primaryColor' : 'border-transparent'}`}>Store and Deals</button>

                        <button onClick={() => changePageType('ABOUT')} className={`w-1/2 text-center py-1 outline-none border-b-2 ${pageType === 'ABOUT' ? 'border-primaryColor' : 'border-transparent'}`}>About us</button>
                    </div>

                    <SearchField />

                    {
                        pageType === 'STORE' && 
                        <>
                            {versionStack[versionIndex]?.versionData?.map(item => {
                                if(item.item.typeData === 'CATEGORY') {
                                    return (
                                        <CategorySection 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'SINGLE_BANNER') {
                                    return (
                                        <SingleBanner 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'CAROUSEL_BANNER') {
                                    return (
                                        <CarouselBanner 
                                            item={item} 
                                            key={item.id} 
                                            options={OPTIONS} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'CATEGORY_COLLECTION_LIST') {
                                    return (
                                        <CategoryCollection 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'CUSTOM_COLLECTION_LIST') {
                                    return (
                                        <CustomCollection 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'OFFER_DISPLAY') {
                                    return (
                                        <OfferDisplay 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                else return null;
                            })}
                        </>
                    }

                    {
                        pageType === 'ABOUT' && 
                        <>
                            {versionStack[versionIndex]?.storeAbout.map(item => {
                                if(item.item.TypeData === 'ABOUT1') {
                                    return (
                                        <AboutOne 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'ABOUT2') {
                                    return (
                                        <AboutTwo 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'ABOUT3') {
                                    return (
                                        <AboutThree 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'FEATURE1') {
                                    return (
                                        <FeaturesOne 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'FEATURE2') {
                                    return (
                                        <FeaturesTwo 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                else return null;
                            })}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default MobilePreview;
